module.exports = __webpack_public_path__ + "static/media/Amancio Ortega.5cc8ec55.jpg";